import React from "react";
import PropertyCard from "../../components/properties/PropertyCard";
import PropertyForm from "../../components/properties/PropertyForm";
import Modal from "../../components/ui/Modal";
import { usePropertyStore } from "../../store/propertyStore";
import { useAgentStore } from "../../store/agentStore";

import { toast } from "react-toastify";

import "../../styles/properties.css";

import { useCreatePropertyMutation, useUpdatePropertyMutation, usePropertiesByAgentQuery } from "../../queries/properties/usePropertiesQuery";
import { useAuthStore } from "../../store/authStore";

export default function Properties({ agentId }) {
  const { role } = useAuthStore();
  const isAdmin = role === "admin";

  const { selectedAgent } = useAgentStore();

  // Always call the hook (rules of hooks), but disable it for non-admin users.
  const agentIdForQuery = isAdmin ? agentId : null;
  const { data: propertiesData = [], isLoading: propertiesLoading } =
    usePropertiesByAgentQuery(agentIdForQuery);

  const properties = isAdmin ? propertiesData : selectedAgent?.properties || [];
  
  const { selectedProperty, clearSelectedProperty } = usePropertyStore();
  
  const createMutation = useCreatePropertyMutation();
  const updateMutation = useUpdatePropertyMutation();
  
  const isEdit = !!selectedProperty?.id;
  const isPending = createMutation.isPending || updateMutation.isPending;
  
  if (propertiesLoading) return <div>Loading...</div>;

  const handleSubmit = (payload) => {
    if (isEdit) {
      updateMutation.mutate(
        {
          agentId,
          propertyId: selectedProperty.id,
          data: payload,
        },
        {
          onSuccess: () => {
            toast.success("Property updated successfully");
            clearSelectedProperty();
          },
          onError: (error) => { 
            const errorMessage = error.response?.data?.message || error.message || "Failed to update property";
            toast.error(errorMessage);
          },
        }
      );
    } else {
      createMutation.mutate(
        {
          agentId,
          data: payload,
        },
        {
          onSuccess: () => {
            toast.success("Property created successfully");
            clearSelectedProperty();
          },
          onError: (error) => {
            const errorMessage = error.response?.data?.message || error.message || "Failed to create property";
            toast.error(errorMessage);
          },
        }
      );
    }
  };
  const propertiesDisplay =
    properties.length > 0 ? (
      properties.map((property) => (
        <PropertyCard key={property.id} property={property} />
      ))
    ) : (
      <div className="text-center text-gray-500">No properties found</div>
    );



  return (
    <>
      <section className="properties-page mx-0">{propertiesDisplay}</section>

      {/* PROPERTY FORM MODAL */}
      <Modal
        isOpen={!!selectedProperty}
        onClose={clearSelectedProperty}
        className="property-form-modal"
        title={isEdit ? "Edit Property" : "Add Property"}
      >
        {selectedProperty && (
          <PropertyForm
            initialData={selectedProperty || {}}
            onSubmit={handleSubmit}
            isLoading={isPending}
            onCancel={clearSelectedProperty}
          />
        )}
      </Modal>     
    </>
  );
}
